import { render, staticRenderFns } from "./ListTitle.vue?vue&type=template&id=5897a763&scoped=true&"
import script from "./ListTitle.vue?vue&type=script&lang=js&"
export * from "./ListTitle.vue?vue&type=script&lang=js&"
import style0 from "./ListTitle.vue?vue&type=style&index=0&id=5897a763&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897a763",
  null
  
)

component.options.__file = "ListTitle.vue"
export default component.exports